var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fill-height",attrs:{"id":"body"}},[_c('v-card',{staticClass:"elevation-24 mx-auto py-5",attrs:{"light":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }